import Seat from './seat'

const Models = {
    Seat
}

export default Models;